(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('covid-facility', {
            parent: 'entity',
            url: '/covid-facility',
            data: {
                authorities: [],
                pageTitle: 'CovidFacilities'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/covid-facility/covid-facilities.html',
                    controller: 'CovidFacilityController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                    var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_COVID_FACILITY];
                    return Auth.loadActionsAccess(actions).$promise;
                }],
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_COVID_FACILITY, access);
                }]
            }
        })
        .state('covid-facility.new', {
            parent: 'covid-facility',
            url: '/new',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'CoreService', 'Auth', 'ACTIONS', 'access', function($stateParams, $state, $uibModal, CoreService, Auth, ACTIONS, access) {
                if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_COVID_FACILITY, access)) {
                    $uibModal.open({
                        templateUrl: 'app/entities/covid-facility/covid-facility-dialog.html',
                        controller: 'CovidFacilityDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        windowTopClass: 'custom-dialog-styles',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    name: null,
                                    id: null,
                                    facility: CoreService.getCurrentFacility()
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('covid-facility', null, {reload: 'covid-facility'});
                    }, function () {
                        $state.go('covid-facility');
                    });
                }
            }]
        })
        .state('covid-facility.edit', {
            parent: 'covid-facility',
            url: '/{id}/edit',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_COVID_FACILITY, access)) {
                    $uibModal.open({
                        templateUrl: 'app/entities/covid-facility/covid-facility-dialog.html',
                        controller: 'CovidFacilityDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        windowTopClass: 'custom-dialog-styles',
                        size: 'lg',
                        resolve: {
                            entity: ['CovidFacility', function (CovidFacility) {
                                return CovidFacility.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('covid-facility', null, {reload: 'covid-facility'});
                    }, function () {
                        $state.go('^');
                    });
                }
            }]
        })
        .state('covid-facility.delete', {
            parent: 'covid-facility',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_COVID_FACILITY, access)) {
                    $uibModal.open({
                        templateUrl: 'app/entities/covid-facility/covid-facility-delete-dialog.html',
                        controller: 'CovidFacilityDeleteController',
                        controllerAs: 'vm',
                        windowTopClass: 'custom-dialog-styles',
                        size: 'md',
                        resolve: {
                            entity: ['CovidFacility', function (CovidFacility) {
                                return CovidFacility.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('covid-facility', null, {reload: 'covid-facility'});
                    }, function () {
                        $state.go('^');
                    });
                }
            }]
        });
    }

})();
